import vars from "../vars";

var bodyNode = document.getElementsByTagName('body')[0];

$(document).ready(function() {
	$('.js-item-filter').on('click', (e) => {
		var selected = document.getElementsByClassName("js-filters-selected");
		$(selected).removeClass('hide');
		bodyNode.classList.add('fixedPosition');
	});

	$('.js-btn-cross').on('click', (e) => {
		var selected = document.getElementsByClassName("js-filters-selected");
		$(selected).addClass('hide');
		bodyNode.classList.remove('fixedPosition');
	});
	
	$('.js-btn-deny').on('click', (e) => {
		var selected = document.getElementsByClassName("js-filters-selected");
		$(selected).addClass('hide');
		bodyNode.classList.remove('fixedPosition');
	});

	if (vars.$materialsFiltersList.height() > 42) {
		vars.$materialsFiltersList.addClass("big");
		vars.$materialsAddition.removeClass("hide");
		vars.$materialsReset.addClass("absolute");
	}
});


// WEBPACK FOOTER //
// ./src/js/general/filters.js